import React from "react";
import compose from "recompose/compose";
import Anchor from "theme/components/atoms/Typography/Link/Anchor";
import EnhanceProductReviews from "./EnhanceProductReviews";
import Review from "../Review";
import Paginator from "theme/components/molecules/Paginator";
import { useLocation } from "react-router";
import LoadingArea from "theme/components/molecules/LoadingArea";
import { FormattedMessage } from "react-intl";
import Stack from "theme/components/atoms/Layout/Stack";
import { Grid, Cell } from "theme/components/templates/Grid";
import LargeProductSynthesis from "../LargeProductSynthesis";

export const anchorId = "reviews";

// since this component also displays a CTA when no reviews
// exist, the only criteria for displaying it or not is whether
// the review feature is enabled or not
export const hasProductReviews = (product) =>
  product.reviewsLayer && product.canBeReviewed;

const ProductReviews = ({ product, loading, reviews, page, maxPage }) => {
  const location = useLocation();

  if (!loading && (!reviews || !hasProductReviews(product))) {
    return null;
  }

  return (
    <>
      <Anchor
        anchor={anchorId}
        title={
          <FormattedMessage
            id="modules.Reviews.ProductReviews.anchorTitle"
            defaultMessage="Reviews"
          />
        }
      />
      <Grid gap="2">
        <Cell size="desktop-1">
          <LargeProductSynthesis product={product} />
        </Cell>
        {product.reviewsLayer.total > 0 ? (
          <Cell size="desktop-2">
            <Stack size="2">
              {loading ? (
                <LoadingArea>
                  <FormattedMessage
                    id="modules.Reviews.ProductReviews.loading"
                    defaultMessage="Loading reviews..."
                  />
                </LoadingArea>
              ) : (
                <Stack size="4">
                  {reviews.map((review, index) => {
                    return (
                      <Review
                        key={page + "-" + index}
                        review={review}
                        itemProp="review"
                      />
                    );
                  })}
                </Stack>
              )}
              <div className="product-reviews__pagination">
                {maxPage > 1 ? (
                  <Paginator
                    maxPage={maxPage}
                    page={page}
                    location={{ ...location, hash: `#${anchorId}` }}
                  />
                ) : null}
              </div>
            </Stack>
          </Cell>
        ) : null}
      </Grid>
    </>
  );
};

export default compose(EnhanceProductReviews())(ProductReviews);
